import module from './module.js'
// Components
import './components/agregar/component.js'
import './components/buscar/component.js'
import './components/buscar/lista/component.js'
// Routes
import './routes/clientes.js'
import './routes/clientes/agregar.js'
import './routes/clientes/buscar.js'
// Services
import './services/Clientes/Agregar.js'
import './services/Clientes/Buscar.js'
import './services/Clientes/Catalogo.js'

export default module.name



// WEBPACK FOOTER //
// ./src/clientes/index.js